export enum RecipientIdType {
    CPR = 'CPR',
    CVR = 'CVR',
    EMAIL = 'EMAIL',
}
